<template>
  <div class="lp-step bg-people-blur">
    <div class="lp-popup">
      <div
        class="step-title"
        style="z-index: 2; margin-bottom: -16px; position: relative;"
      >
        {{ $t('lps.How old are you?') }}
      </div>
      <div class="d-flex justify-content-center">
        <scroll-picker
          v-model="age"
          :options="ages.map(a => ({name: a, value: a}))"
          style="width: 100px"
        />
      </div>
      <b-button
        class="mt-0"
        type="submit"
        variant="primary"
        block
        style="background-color: #AC33F4 !important; color: #fff !important; padding: 16px; border-radius: 16px;"
        :disabled="loading"
        @click="$emit('nextStep')"
      >
        <b-spinner
          v-if="loading"
          small
        />
        {{ $t('Next') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { ScrollPicker } from 'vue-scroll-picker'
import 'vue-scroll-picker/dist/style.css'
import { BButton, BSpinner } from 'bootstrap-vue'

export default {
  name: 'Lp3Step2',
  components: {
    BButton,
    BSpinner,
    ScrollPicker,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      age: 18,
      ages: [...Array(73).keys()].map(i => i + 18),
    }
  },
  watch: {
    age(value) {
      this.$emit('setAge', value)
    },
  },
}
</script>
